import {ChartView} from './ChartView';

export default ChartView;